/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import project from './modules/project';
import playback from './modules/playback';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    project,
    playback,
  },
});
